import { useMutation, useQueryClient } from '@tanstack/react-query';
import { initiateElemisApplication, type InitiateElemisApplicationOptions } from '../services/agreements';
import { agreementKeys } from './agreementKeys';

/** Agreements Slice 3 (#901). NO optimistic update: the server owns every
 *  fail-closed refusal and can legitimately 422/409 — an optimistic
 *  "checkout ready" would put a payment surface on screen and then have to
 *  retract it. */
export function useInitiateElemisApplicationMutation(quoteId: string) {
    const queryClient = useQueryClient();
    return useMutation({
        // `| void` keeps the existing zero-argument `mutate()` call sites compiling.
        mutationFn: (variables: InitiateElemisApplicationOptions | void) =>
            initiateElemisApplication(quoteId, variables ?? {}),
        onSuccess: () => {
            // An Agreement may have just been created for this quote, so the
            // by-quote lookup /agreements/quote/:quoteId resolves through is
            // now stale. ONLY this key: the quote itself is unchanged (still
            // `live`), so invalidating quoteKeys.detail would refetch for no
            // reason (AC-12).
            queryClient.invalidateQueries({ queryKey: agreementKeys.byQuote(quoteId) });
        },
    });
}
